
import { supabase } from '@/lib/supabase';
import type { UserProfile } from '@/types/auth';

/**
 * Fetches user profile data from Supabase
 */
export const fetchUserProfile = async (userId: string): Promise<UserProfile | null> => {
  try {
    const { data, error } = await supabase
      .from('users_p')
      .select('*')
      .eq('id', userId)
      .maybeSingle();

    if (error) {
      console.error('Erreur lors de la récupération du profil utilisateur:', error);
      return null;
    }

    console.log('Profil utilisateur récupéré:', data);
    return data as UserProfile;
  } catch (error) {
    console.error('Exception dans fetchUserProfile:', error);
    return null;
  }
};

/**
 * List of routes that don't require authentication
 */
export const PUBLIC_ROUTES = ['/login', '/register', '/forgot-password', '/reset-password'];

/**
 * Checks if a route is public (doesn't require authentication)
 */
export const isPublicRoute = (pathname: string): boolean => {
  return PUBLIC_ROUTES.some(route => 
    pathname === route || pathname.startsWith(route + '/')
  );
};
